import {getDashboardContextFromPath} from './getDashboardContextFromPath';

export function getStoryboardTabBasePathFromPath(
    pathname: string,
    dummyStorySlug: string,
): string | null {
    if (
        pathname.startsWith('/app/discover/my-stories/boards') ||
        pathname.startsWith('/app/discover/shared-stories/boards')
    ) {
        return pathname;
    }

    // For dashboard/special-story contexts, we still rely on dummyStorySlug.
    if (!dummyStorySlug) {
        return null;
    }

    const dashboardContext = getDashboardContextFromPath(pathname);
    if (dashboardContext && dashboardContext.type === dummyStorySlug) {
        return `/app/${dashboardContext.type}/${dashboardContext.objectId}/dashboard`;
    }

    if (pathname.startsWith('/app/conversations/')) {
        const match = pathname.match(/^\/app\/conversations\/(calls|emails|chats|feedbacks)\/analytics(?:\/|$)/);
        if (!match) {
            return null;
        }

        const section = match[1];
        const normalizedDummyStorySlug = section === 'feedbacks' ? 'feedback' : section;
        if (normalizedDummyStorySlug !== dummyStorySlug) {
            return null;
        }

        return pathname;
    }

    return null;
}

